import React, { Fragment, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { VariableActions } from '../../../store/actions/variables';
import { ValidationType } from '../../../util/validation-type';

import Select from '../../Select';

export default (props) => {
  const {
    answerHandlerOpen,
    toggleAnswerHandler,
    variable,
    validationTypeName,
    validationTypeIcon,
    validationDowndownOpen,
    toggleValidationDropDown,
    validationType,
    validation,
    captureAnswer,
    handleCapture,
    onVariableUpdate,
    handleValidationChanged,
    onValidationUpdate,
    match,
  } = props;

  const { variables } = useSelector((state) => state.variables.variablesState);

  const dispatch = useDispatch();
  const { botid: botId } = match.params;

  const formattedVariableOptions = useMemo(() => {
    return variables && variables.bot
      ? variables.bot.map((_variable) => ({
          value: _variable.name,
          label: _variable.name,
        }))
      : [];
  }, [variables]);

  const selectedVariableToSelect = useMemo(() => {
    if (!formattedVariableOptions) return null;
    const findVariable = formattedVariableOptions.find(
      (_variable) => _variable.value === variable
    );

    if (findVariable) return findVariable;

    return null;
  }, [formattedVariableOptions, variable]);

  const handleChangeVariable = useCallback(
    (arrayWithNewValue) => {
      const newVariable = !arrayWithNewValue
        ? { value: '', label: '' }
        : arrayWithNewValue.find(
            (newVariable) => newVariable.value !== variable
          );

      onVariableUpdate(newVariable.value);
    },
    [onVariableUpdate, variable]
  );

  const handleCreateVariableOption = useCallback(
    (inputValue) => {
      const payload = {
        botId,
        type: 'user',
        active: true,
        name: inputValue,
        value: '',
      };

      dispatch(VariableActions.create(payload));
      onVariableUpdate(inputValue);
    },
    [botId, dispatch, onVariableUpdate]
  );

  return (
    <Fragment>
      {/* MANIPULAÇÃO DE RESPOSTA */}
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        Manipulação de Resposta
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>
      {/* SALVAR RESPOSTA PARA VARIÁVEL */}
      <div className="form-group row mb-1" hidden={!answerHandlerOpen}>
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            name="captureAnswer"
            id="captureAnswer"
            checked={captureAnswer || false}
            disabled={props.item && props.item.type === 'Menu'}
            onChange={handleCapture}
            onClick={() => {
              document.getElementById('captureAnswer').checked =
                !document.getElementById('captureAnswer').checked;
            }}
          />
          <label className="custom-control-label" htmlFor="captureAnswer">
            Salvar resposta para variável
          </label>
        </div>
      </div>
      {captureAnswer && (
        <div>
          <div className="form-group mb-1" hidden={!answerHandlerOpen}>
            <Select
              options={formattedVariableOptions}
              value={selectedVariableToSelect}
              onChange={(value) => handleChangeVariable(value)}
              onCreateOption={(value) => handleCreateVariableOption(value)}
              isMulti
              isCreatable
            />
          </div>

          {/* VALIDAÇÃO */}
          <div
            className="form-group validation-input-group mb-1"
            hidden={!answerHandlerOpen}
          >
            <label>Validação</label>
            <input
              type="text"
              disabled
              className="form-control outline-none input-control mt-1"
              value={validationTypeName}
            />
            <img
              className="validation-input-icon"
              src={require(`../../../assets/images/validacao_${validationTypeIcon}_dark.svg`)}
              alt=""
            />
            <i className="arrow down" />
            <button
              disabled={props.item && props.item.type === 'Menu'}
              onClick={toggleValidationDropDown}
            />
            {/* VALIDAÇÃO DROPDOWN */}
            <div
              className="validation-dropdown"
              hidden={!validationDowndownOpen}
            >
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.Any)}
              >
                <span className="image qualquer-coisa" />
                <span>Qualquer Coisa</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Any}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.Email)}
              >
                <span className="image email" />
                <span>Email</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Email}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.CPF)}
              >
                <span className="image cpf" />
                <span>CPF</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.CPF}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.CNPJ)}
              >
                <span className="image cnpj" />
                <span>CNPJ</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.CNPJ}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.Date)}
              >
                <span className="image data" />
                <span>Data (dd/mm/aaaa)</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Date}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() =>
                  handleValidationChanged(ValidationType.Cellphone)
                }
              >
                <span className="image celular" />
                <span>Telefone</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Cellphone}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.Url)}
              >
                <span className="image url" />
                <span>Url</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Url}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() => handleValidationChanged(ValidationType.Number)}
              >
                <span className="image numero" />
                <span>Número</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Number}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() =>
                  handleValidationChanged(ValidationType.RegularExpression)
                }
              >
                <span className="image expressao" />
                <span>Expressão Regular</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.RegularExpression}
                />
              </div>
              {/* VALIDAÇÃO DROPDOWN LINE */}
              <div
                className="validation-dropdown-line"
                onClick={() =>
                  handleValidationChanged(ValidationType.Localization)
                }
              >
                <span className="image localizacao" />
                <span>Localização</span>
                <i
                  className="arrow down"
                  hidden={validationType !== ValidationType.Localization}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group validation-input-group-expression mb-1"
            hidden={
              validationType !== ValidationType.RegularExpression ||
              !answerHandlerOpen
            }
          >
            <label>Padrão da Expressão</label>
            <input
              type="text"
              id="common-validation"
              placeholder="ex: [A-Z,a-z,0-9]"
              value={validation || ''}
              onChange={onValidationUpdate}
              className="form-control outline-none input-control mt-1"
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};
